import { RoomInventoryResponse, RoomInventoryItem, RoomDataTodayResponse } from '@/types/room-inventory';
import { apiClient, API_ENDPOINTS, USE_MOCK } from './client';
import { delay } from './client';

// Mock room inventory data based on the uploaded JSON
const mockRoomInventoryData: RoomInventoryResponse = {
  success: true,
  total: 10,
  data: [
    {
      id: 21,
      org_id: 4,
      branch_id: 5,
      room_type: "HUT",
      room_measurement: "196",
      no_of_beds: 2,
      num_of_bathrooms: 1,
      num_of_adult_max: 4,
      num_of_child_max: 2,
      num_of_adult_min: 4,
      num_of_child_min: 2,
      num_of_windows: 2,
      no_of_extra_person: null,
      basic_room_rate: "2000.00",
      basic_rate_set_date: "2025-08-28T12:24:38.000Z",
      base_num_of_rooms: "2",
      base_num_of_room_set_date: "2025-08-28T12:24:38.000Z",
      is_balcony_available: false,
      num_of_balcony: 0,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "",
      tag: null,
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T12:22:40.000Z",
      HotelBranchData: {
        id: 5,
        org_id: 4,
        branch_name: "Sonkupi Banjara Camp",
        email1: "puruliabanjaracamp@gmail.com",
        is_verified: true,
        email2: "",
        contact1: "919641858953",
        contact2: "",
        address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143",
        address2: "purulia",
        city: "purulia",
        state: "west bengal",
        zip: "723143",
        country: "india",
        google_location: "",
        owner_name: "Sujit Chandra Kumar",
        owner_address: "",
        currency: "INR",
        upi_id: "chhowburu1@ybl",
        qr_img_url: "",
        bank_details: "",
        breakfast_rate: "0.00",
        lunch_rate: "0.00",
        dinner_rate: "0.00",
        star_category: "0",
        property_type: "Homestay",
        can_be_booked: true,
        description: null,
        tag1: "",
        tag2: "",
        tag3: "",
        child_age_limit: 11,
        child_fooding: "",
        is_active: true,
        inactive_date: null,
        is_deleted: false,
        timezone: "Asia/Kolkata",
        social_media_url: "[]",
        branch_logo: "",
        is_beneficiary_included: false,
        is_agent: false,
        brochure_url: "",
        is_default: false,
        in_house_product: false,
        slug: "homestay-purulia-sonkupi-banjara-camp-NC01",
        branch_description: "",
        managed_by: "",
        HotelBranchFacilityData: []
      },
      HotelRoomData: [
        {
          id: 144,
          org_id: 4,
          branch_id: 5,
          room_type_id: 21,
          room_number: "HUT1",
          is_active: true,
          HotelRoomPropertyRelation: [{ tag: "", room_measurement: "196", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }],
          HotelRoomFacilityRelation: [],
          basic_room_rate_with_special_rate: "2000.00"
        },
        {
          id: 145,
          org_id: 4,
          branch_id: 5,
          room_type_id: 21,
          room_number: "HUT2",
          is_active: true,
          HotelRoomPropertyRelation: [{ tag: "", room_measurement: "196", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }],
          HotelRoomFacilityRelation: [],
          basic_room_rate_with_special_rate: "2000.00"
        }
      ],
      RoomTypeFacilityRelation: [
        { id: 132, org_id: 4, branch_id: 5, room_type_id: 21, facility_id: 24, RoomTypeFacilityRelationData: { id: 24, org_id: 4, facility_name: "Free WIFI", logo_url: "", is_active: true } },
        { id: 133, org_id: 4, branch_id: 5, room_type_id: 21, facility_id: 25, RoomTypeFacilityRelationData: { id: 25, org_id: 4, facility_name: "Geyser", logo_url: "", is_active: true } },
        { id: 134, org_id: 4, branch_id: 5, room_type_id: 21, facility_id: 26, RoomTypeFacilityRelationData: { id: 26, org_id: 4, facility_name: "Free parking", logo_url: "", is_active: true } }
      ],
      HotelRoomTypeVarientRelData: [
        {
          id: 30,
          room_type_id: 21,
          variant_id: 30,
          variant_wise_code: "HUT-4A2C-AP",
          VarientRoomTypeDataRel: {
            id: 30,
            org_id: 4,
            branch_id: 5,
            start_date: null,
            end_date: null,
            code: "4A2C-AP",
            name: "All Meal Plan",
            charge_basis: "per_room",
            max_adults: 4,
            max_children: 2,
            base_price: "700.00",
            rate_per_adult: null,
            rate_per_child: null,
            img_url: null,
            is_active: true,
            is_marketplace_availability: true,
            is_separate_from_room_type: false,
            VariantCompRelData: [
              {
                id: 19,
                variant_id: 30,
                component_id: 6,
                quantity: 1,
                component_price: "700.00",
                breakfast_rate: "100.00",
                lunch_rate: "300.00",
                dinner_rate: "300.00",
                componentData: {
                  id: 6,
                  org_id: 4,
                  branch_id: 5,
                  code: "AP",
                  name: "ALL MEAL",
                  component_type: "meal",
                  includes_breakfast: true,
                  includes_lunch: true,
                  includes_dinner: true,
                  is_variable_quantity: false,
                  unit_label: null,
                  base_price: "700.00",
                  breakfast_rate: "100.00",
                  lunch_rate: "300.00",
                  dinner_rate: "300.00",
                  bed_size: null,
                  max_adults: null,
                  max_children: null,
                  is_active: true,
                  description: null
                }
              }
            ]
          },
          computed_base_price: "700.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 30, name: "All Meal Plan", variant_wise_code: "HUT-4A2C-AP", base_price: "2700.00" }]
    },
    {
      id: 20,
      org_id: 4,
      branch_id: 5,
      room_type: "20 Beded Dormitory Tent",
      room_measurement: "500",
      no_of_beds: 20,
      num_of_bathrooms: 10,
      num_of_adult_max: 20,
      num_of_child_max: 5,
      num_of_adult_min: 20,
      num_of_child_min: 5,
      num_of_windows: 8,
      no_of_extra_person: null,
      basic_room_rate: "6000.00",
      basic_rate_set_date: "2025-08-28T12:20:22.000Z",
      base_num_of_rooms: "1",
      base_num_of_room_set_date: "2025-08-28T12:20:22.000Z",
      is_balcony_available: false,
      num_of_balcony: 0,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "",
      tag: null,
      is_active: true,
      is_dormitory: true,
      createdAt: "2025-08-28T12:20:22.000Z",
      HotelBranchData: {
        id: 5,
        org_id: 4,
        branch_name: "Sonkupi Banjara Camp",
        email1: "puruliabanjaracamp@gmail.com",
        is_verified: true,
        email2: "",
        contact1: "919641858953",
        contact2: "",
        address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143",
        address2: "purulia",
        city: "purulia",
        state: "west bengal",
        zip: "723143",
        country: "india",
        google_location: "",
        owner_name: "Sujit Chandra Kumar",
        owner_address: "",
        currency: "INR",
        upi_id: "chhowburu1@ybl",
        qr_img_url: "",
        bank_details: "",
        breakfast_rate: "0.00",
        lunch_rate: "0.00",
        dinner_rate: "0.00",
        star_category: "0",
        property_type: "Homestay",
        can_be_booked: true,
        description: null,
        tag1: "",
        tag2: "",
        tag3: "",
        child_age_limit: 11,
        child_fooding: "",
        is_active: true,
        inactive_date: null,
        is_deleted: false,
        timezone: "Asia/Kolkata",
        social_media_url: "[]",
        branch_logo: "",
        is_beneficiary_included: false,
        is_agent: false,
        brochure_url: "",
        is_default: false,
        in_house_product: false,
        slug: "homestay-purulia-sonkupi-banjara-camp-NC01",
        branch_description: "",
        managed_by: "",
        HotelBranchFacilityData: []
      },
      HotelRoomData: [
        {
          id: 143,
          org_id: 4,
          branch_id: 5,
          room_type_id: 20,
          room_number: "DORM1",
          is_active: true,
          HotelRoomPropertyRelation: [{ tag: "", room_measurement: "500", num_of_bathrooms: 10, num_of_adult_max: 20, num_of_child_max: 5, num_of_windows: 8 }],
          HotelRoomFacilityRelation: [],
          basic_room_rate_with_special_rate: "6000.00"
        }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 29,
          room_type_id: 20,
          variant_id: 29,
          variant_wise_code: "DORM-20A5C-EP",
          VarientRoomTypeDataRel: {
            id: 29,
            org_id: 4,
            branch_id: 5,
            start_date: null,
            end_date: null,
            code: "20A5C-EP",
            name: "Room Only",
            charge_basis: "per_room",
            max_adults: 20,
            max_children: 5,
            base_price: "0.00",
            rate_per_adult: null,
            rate_per_child: null,
            img_url: null,
            is_active: true,
            is_marketplace_availability: true,
            is_separate_from_room_type: false,
            VariantCompRelData: []
          },
          computed_base_price: "0.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 29, name: "Room Only", variant_wise_code: "DORM-20A5C-EP", base_price: "6000.00" }]
    },
    {
      id: 19,
      org_id: 4,
      branch_id: 5,
      room_type: "Doble Beded Non Attached Tent",
      room_measurement: "160",
      no_of_beds: 2,
      num_of_bathrooms: 0,
      num_of_adult_max: 3,
      num_of_child_max: 2,
      num_of_adult_min: 3,
      num_of_child_min: 2,
      num_of_windows: 2,
      no_of_extra_person: null,
      basic_room_rate: "1600.00",
      basic_rate_set_date: "2025-08-28T12:18:13.000Z",
      base_num_of_rooms: "3",
      base_num_of_room_set_date: "2025-08-28T12:18:13.000Z",
      is_balcony_available: false,
      num_of_balcony: 0,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "",
      tag: null,
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T12:18:13.000Z",
      HotelBranchData: {
        id: 5,
        org_id: 4,
        branch_name: "Sonkupi Banjara Camp",
        email1: "puruliabanjaracamp@gmail.com",
        is_verified: true,
        email2: "",
        contact1: "919641858953",
        contact2: "",
        address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143",
        address2: "purulia",
        city: "purulia",
        state: "west bengal",
        zip: "723143",
        country: "india",
        google_location: "",
        owner_name: "Sujit Chandra Kumar",
        owner_address: "",
        currency: "INR",
        upi_id: "chhowburu1@ybl",
        qr_img_url: "",
        bank_details: "",
        breakfast_rate: "0.00",
        lunch_rate: "0.00",
        dinner_rate: "0.00",
        star_category: "0",
        property_type: "Homestay",
        can_be_booked: true,
        description: null,
        tag1: "",
        tag2: "",
        tag3: "",
        child_age_limit: 11,
        child_fooding: "",
        is_active: true,
        inactive_date: null,
        is_deleted: false,
        timezone: "Asia/Kolkata",
        social_media_url: "[]",
        branch_logo: "",
        is_beneficiary_included: false,
        is_agent: false,
        brochure_url: "",
        is_default: false,
        in_house_product: false,
        slug: "homestay-purulia-sonkupi-banjara-camp-NC01",
        branch_description: "",
        managed_by: "",
        HotelBranchFacilityData: []
      },
      HotelRoomData: [
        {
          id: 140,
          org_id: 4,
          branch_id: 5,
          room_type_id: 19,
          room_number: "NAT1",
          is_active: true,
          HotelRoomPropertyRelation: [{ tag: "", room_measurement: "160", num_of_bathrooms: 0, num_of_adult_max: 3, num_of_child_max: 2, num_of_windows: 2 }],
          HotelRoomFacilityRelation: [],
          basic_room_rate_with_special_rate: "1600.00"
        },
        {
          id: 141,
          org_id: 4,
          branch_id: 5,
          room_type_id: 19,
          room_number: "NAT2",
          is_active: true,
          HotelRoomPropertyRelation: [{ tag: "", room_measurement: "160", num_of_bathrooms: 0, num_of_adult_max: 3, num_of_child_max: 2, num_of_windows: 2 }],
          HotelRoomFacilityRelation: [],
          basic_room_rate_with_special_rate: "1600.00"
        },
        {
          id: 142,
          org_id: 4,
          branch_id: 5,
          room_type_id: 19,
          room_number: "NAT3",
          is_active: true,
          HotelRoomPropertyRelation: [{ tag: "", room_measurement: "160", num_of_bathrooms: 0, num_of_adult_max: 3, num_of_child_max: 2, num_of_windows: 2 }],
          HotelRoomFacilityRelation: [],
          basic_room_rate_with_special_rate: "1600.00"
        }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 28,
          room_type_id: 19,
          variant_id: 28,
          variant_wise_code: "NAT-3A2C-CP",
          VarientRoomTypeDataRel: {
            id: 28,
            org_id: 4,
            branch_id: 5,
            start_date: null,
            end_date: null,
            code: "3A2C-CP",
            name: "Continental Plan",
            charge_basis: "per_room",
            max_adults: 3,
            max_children: 2,
            base_price: "200.00",
            rate_per_adult: null,
            rate_per_child: null,
            img_url: null,
            is_active: true,
            is_marketplace_availability: true,
            is_separate_from_room_type: false,
            VariantCompRelData: []
          },
          computed_base_price: "200.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 28, name: "Continental Plan", variant_wise_code: "NAT-3A2C-CP", base_price: "1800.00" }]
    },
    {
      id: 18,
      org_id: 4,
      branch_id: 5,
      room_type: "4 Beded Delux Tent",
      room_measurement: "200",
      no_of_beds: 4,
      num_of_bathrooms: 1,
      num_of_adult_max: 4,
      num_of_child_max: 2,
      num_of_adult_min: 4,
      num_of_child_min: 2,
      num_of_windows: 2,
      no_of_extra_person: null,
      basic_room_rate: "2500.00",
      basic_rate_set_date: "2025-08-28T12:15:45.000Z",
      base_num_of_rooms: "4",
      base_num_of_room_set_date: "2025-08-28T12:15:45.000Z",
      is_balcony_available: false,
      num_of_balcony: 0,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "",
      tag: null,
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T12:15:45.000Z",
      HotelBranchData: {
        id: 5,
        org_id: 4,
        branch_name: "Sonkupi Banjara Camp",
        email1: "puruliabanjaracamp@gmail.com",
        is_verified: true,
        email2: "",
        contact1: "919641858953",
        contact2: "",
        address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143",
        address2: "purulia",
        city: "purulia",
        state: "west bengal",
        zip: "723143",
        country: "india",
        google_location: "",
        owner_name: "Sujit Chandra Kumar",
        owner_address: "",
        currency: "INR",
        upi_id: "chhowburu1@ybl",
        qr_img_url: "",
        bank_details: "",
        breakfast_rate: "0.00",
        lunch_rate: "0.00",
        dinner_rate: "0.00",
        star_category: "0",
        property_type: "Homestay",
        can_be_booked: true,
        description: null,
        tag1: "",
        tag2: "",
        tag3: "",
        child_age_limit: 11,
        child_fooding: "",
        is_active: true,
        inactive_date: null,
        is_deleted: false,
        timezone: "Asia/Kolkata",
        social_media_url: "[]",
        branch_logo: "",
        is_beneficiary_included: false,
        is_agent: false,
        brochure_url: "",
        is_default: false,
        in_house_product: false,
        slug: "homestay-purulia-sonkupi-banjara-camp-NC01",
        branch_description: "",
        managed_by: "",
        HotelBranchFacilityData: []
      },
      HotelRoomData: [
        { id: 136, org_id: 4, branch_id: 5, room_type_id: 18, room_number: "DT1", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2500.00" },
        { id: 137, org_id: 4, branch_id: 5, room_type_id: 18, room_number: "DT2", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2500.00" },
        { id: 138, org_id: 4, branch_id: 5, room_type_id: 18, room_number: "DT3", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2500.00" },
        { id: 139, org_id: 4, branch_id: 5, room_type_id: 18, room_number: "DT4", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2500.00" }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 27,
          room_type_id: 18,
          variant_id: 27,
          variant_wise_code: "DT-4A2C-MAP",
          VarientRoomTypeDataRel: {
            id: 27,
            org_id: 4,
            branch_id: 5,
            start_date: null,
            end_date: null,
            code: "4A2C-MAP",
            name: "Modified American Plan",
            charge_basis: "per_room",
            max_adults: 4,
            max_children: 2,
            base_price: "400.00",
            rate_per_adult: null,
            rate_per_child: null,
            img_url: null,
            is_active: true,
            is_marketplace_availability: true,
            is_separate_from_room_type: false,
            VariantCompRelData: []
          },
          computed_base_price: "400.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 27, name: "Modified American Plan", variant_wise_code: "DT-4A2C-MAP", base_price: "2900.00" }]
    },
    {
      id: 17,
      org_id: 4,
      branch_id: 5,
      room_type: "Double Beded Delux Tent",
      room_measurement: "180",
      no_of_beds: 2,
      num_of_bathrooms: 1,
      num_of_adult_max: 2,
      num_of_child_max: 1,
      num_of_adult_min: 2,
      num_of_child_min: 1,
      num_of_windows: 2,
      no_of_extra_person: null,
      basic_room_rate: "1800.00",
      basic_rate_set_date: "2025-08-28T12:13:00.000Z",
      base_num_of_rooms: "5",
      base_num_of_room_set_date: "2025-08-28T12:13:00.000Z",
      is_balcony_available: false,
      num_of_balcony: 0,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "",
      tag: null,
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T12:13:00.000Z",
      HotelBranchData: {
        id: 5, org_id: 4, branch_name: "Sonkupi Banjara Camp", email1: "puruliabanjaracamp@gmail.com", is_verified: true, email2: "", contact1: "919641858953", contact2: "", address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143", address2: "purulia", city: "purulia", state: "west bengal", zip: "723143", country: "india", google_location: "", owner_name: "Sujit Chandra Kumar", owner_address: "", currency: "INR", upi_id: "chhowburu1@ybl", qr_img_url: "", bank_details: "", breakfast_rate: "0.00", lunch_rate: "0.00", dinner_rate: "0.00", star_category: "0", property_type: "Homestay", can_be_booked: true, description: null, tag1: "", tag2: "", tag3: "", child_age_limit: 11, child_fooding: "", is_active: true, inactive_date: null, is_deleted: false, timezone: "Asia/Kolkata", social_media_url: "[]", branch_logo: "", is_beneficiary_included: false, is_agent: false, brochure_url: "", is_default: false, in_house_product: false, slug: "homestay-purulia-sonkupi-banjara-camp-NC01", branch_description: "", managed_by: "", HotelBranchFacilityData: []
      },
      HotelRoomData: [
        { id: 131, org_id: 4, branch_id: 5, room_type_id: 17, room_number: "DBT1", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "180", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "1800.00" },
        { id: 132, org_id: 4, branch_id: 5, room_type_id: 17, room_number: "DBT2", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "180", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "1800.00" },
        { id: 133, org_id: 4, branch_id: 5, room_type_id: 17, room_number: "DBT3", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "180", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "1800.00" },
        { id: 134, org_id: 4, branch_id: 5, room_type_id: 17, room_number: "DBT4", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "180", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "1800.00" },
        { id: 135, org_id: 4, branch_id: 5, room_type_id: 17, room_number: "DBT5", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "180", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "1800.00" }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 26,
          room_type_id: 17,
          variant_id: 26,
          variant_wise_code: "DBT-2A1C-EP",
          VarientRoomTypeDataRel: { id: 26, org_id: 4, branch_id: 5, start_date: null, end_date: null, code: "2A1C-EP", name: "Room Only", charge_basis: "per_room", max_adults: 2, max_children: 1, base_price: "0.00", rate_per_adult: null, rate_per_child: null, img_url: null, is_active: true, is_marketplace_availability: true, is_separate_from_room_type: false, VariantCompRelData: [] },
          computed_base_price: "0.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 26, name: "Room Only", variant_wise_code: "DBT-2A1C-EP", base_price: "1800.00" }]
    },
    {
      id: 16,
      org_id: 4,
      branch_id: 5,
      room_type: "LUXURY TENT",
      room_measurement: "300",
      no_of_beds: 2,
      num_of_bathrooms: 1,
      num_of_adult_max: 2,
      num_of_child_max: 0,
      num_of_adult_min: 2,
      num_of_child_min: 0,
      num_of_windows: 4,
      no_of_extra_person: null,
      basic_room_rate: "5000.00",
      basic_rate_set_date: "2025-08-28T12:10:00.000Z",
      base_num_of_rooms: "2",
      base_num_of_room_set_date: "2025-08-28T12:10:00.000Z",
      is_balcony_available: true,
      num_of_balcony: 1,
      is_breakfast_available: true,
      is_lunch_available: true,
      is_dinner_available: true,
      description: "Premium luxury tent with all amenities",
      tag: "premium",
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T12:10:00.000Z",
      HotelBranchData: {
        id: 5, org_id: 4, branch_name: "Sonkupi Banjara Camp", email1: "puruliabanjaracamp@gmail.com", is_verified: true, email2: "", contact1: "919641858953", contact2: "", address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143", address2: "purulia", city: "purulia", state: "west bengal", zip: "723143", country: "india", google_location: "", owner_name: "Sujit Chandra Kumar", owner_address: "", currency: "INR", upi_id: "chhowburu1@ybl", qr_img_url: "", bank_details: "", breakfast_rate: "0.00", lunch_rate: "0.00", dinner_rate: "0.00", star_category: "0", property_type: "Homestay", can_be_booked: true, description: null, tag1: "", tag2: "", tag3: "", child_age_limit: 11, child_fooding: "", is_active: true, inactive_date: null, is_deleted: false, timezone: "Asia/Kolkata", social_media_url: "[]", branch_logo: "", is_beneficiary_included: false, is_agent: false, brochure_url: "", is_default: false, in_house_product: false, slug: "homestay-purulia-sonkupi-banjara-camp-NC01", branch_description: "", managed_by: "", HotelBranchFacilityData: []
      },
      HotelRoomData: [
        { id: 129, org_id: 4, branch_id: 5, room_type_id: 16, room_number: "LUX1", is_active: true, HotelRoomPropertyRelation: [{ tag: "premium", room_measurement: "300", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 0, num_of_windows: 4 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "5000.00" },
        { id: 130, org_id: 4, branch_id: 5, room_type_id: 16, room_number: "LUX2", is_active: true, HotelRoomPropertyRelation: [{ tag: "premium", room_measurement: "300", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 0, num_of_windows: 4 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "5000.00" }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 25,
          room_type_id: 16,
          variant_id: 25,
          variant_wise_code: "LUX-2A0C-AP",
          VarientRoomTypeDataRel: { id: 25, org_id: 4, branch_id: 5, start_date: null, end_date: null, code: "2A0C-AP", name: "All Inclusive", charge_basis: "per_room", max_adults: 2, max_children: 0, base_price: "1000.00", rate_per_adult: null, rate_per_child: null, img_url: null, is_active: true, is_marketplace_availability: true, is_separate_from_room_type: false, VariantCompRelData: [] },
          computed_base_price: "1000.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 25, name: "All Inclusive", variant_wise_code: "LUX-2A0C-AP", base_price: "6000.00" }]
    },
    {
      id: 15,
      org_id: 4,
      branch_id: 5,
      room_type: "4 BEDED AC ROOM",
      room_measurement: "250",
      no_of_beds: 4,
      num_of_bathrooms: 1,
      num_of_adult_max: 4,
      num_of_child_max: 2,
      num_of_adult_min: 4,
      num_of_child_min: 2,
      num_of_windows: 2,
      no_of_extra_person: null,
      basic_room_rate: "3000.00",
      basic_rate_set_date: "2025-08-28T12:05:00.000Z",
      base_num_of_rooms: "3",
      base_num_of_room_set_date: "2025-08-28T12:05:00.000Z",
      is_balcony_available: false,
      num_of_balcony: 0,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "",
      tag: null,
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T12:05:00.000Z",
      HotelBranchData: {
        id: 5, org_id: 4, branch_name: "Sonkupi Banjara Camp", email1: "puruliabanjaracamp@gmail.com", is_verified: true, email2: "", contact1: "919641858953", contact2: "", address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143", address2: "purulia", city: "purulia", state: "west bengal", zip: "723143", country: "india", google_location: "", owner_name: "Sujit Chandra Kumar", owner_address: "", currency: "INR", upi_id: "chhowburu1@ybl", qr_img_url: "", bank_details: "", breakfast_rate: "0.00", lunch_rate: "0.00", dinner_rate: "0.00", star_category: "0", property_type: "Homestay", can_be_booked: true, description: null, tag1: "", tag2: "", tag3: "", child_age_limit: 11, child_fooding: "", is_active: true, inactive_date: null, is_deleted: false, timezone: "Asia/Kolkata", social_media_url: "[]", branch_logo: "", is_beneficiary_included: false, is_agent: false, brochure_url: "", is_default: false, in_house_product: false, slug: "homestay-purulia-sonkupi-banjara-camp-NC01", branch_description: "", managed_by: "", HotelBranchFacilityData: []
      },
      HotelRoomData: [
        { id: 126, org_id: 4, branch_id: 5, room_type_id: 15, room_number: "AC1", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "250", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "3000.00" },
        { id: 127, org_id: 4, branch_id: 5, room_type_id: 15, room_number: "AC2", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "250", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "3000.00" },
        { id: 128, org_id: 4, branch_id: 5, room_type_id: 15, room_number: "AC3", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "250", num_of_bathrooms: 1, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "3000.00" }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 24,
          room_type_id: 15,
          variant_id: 24,
          variant_wise_code: "AC-4A2C-CP",
          VarientRoomTypeDataRel: { id: 24, org_id: 4, branch_id: 5, start_date: null, end_date: null, code: "4A2C-CP", name: "Continental Plan", charge_basis: "per_room", max_adults: 4, max_children: 2, base_price: "200.00", rate_per_adult: null, rate_per_child: null, img_url: null, is_active: true, is_marketplace_availability: true, is_separate_from_room_type: false, VariantCompRelData: [] },
          computed_base_price: "200.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 24, name: "Continental Plan", variant_wise_code: "AC-4A2C-CP", base_price: "3200.00" }]
    },
    {
      id: 14,
      org_id: 4,
      branch_id: 5,
      room_type: "Double Bed AC Round Cottage",
      room_measurement: "220",
      no_of_beds: 2,
      num_of_bathrooms: 1,
      num_of_adult_max: 2,
      num_of_child_max: 1,
      num_of_adult_min: 2,
      num_of_child_min: 1,
      num_of_windows: 3,
      no_of_extra_person: null,
      basic_room_rate: "3500.00",
      basic_rate_set_date: "2025-08-28T12:00:00.000Z",
      base_num_of_rooms: "4",
      base_num_of_room_set_date: "2025-08-28T12:00:00.000Z",
      is_balcony_available: true,
      num_of_balcony: 1,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "",
      tag: null,
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T12:00:00.000Z",
      HotelBranchData: {
        id: 5, org_id: 4, branch_name: "Sonkupi Banjara Camp", email1: "puruliabanjaracamp@gmail.com", is_verified: true, email2: "", contact1: "919641858953", contact2: "", address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143", address2: "purulia", city: "purulia", state: "west bengal", zip: "723143", country: "india", google_location: "", owner_name: "Sujit Chandra Kumar", owner_address: "", currency: "INR", upi_id: "chhowburu1@ybl", qr_img_url: "", bank_details: "", breakfast_rate: "0.00", lunch_rate: "0.00", dinner_rate: "0.00", star_category: "0", property_type: "Homestay", can_be_booked: true, description: null, tag1: "", tag2: "", tag3: "", child_age_limit: 11, child_fooding: "", is_active: true, inactive_date: null, is_deleted: false, timezone: "Asia/Kolkata", social_media_url: "[]", branch_logo: "", is_beneficiary_included: false, is_agent: false, brochure_url: "", is_default: false, in_house_product: false, slug: "homestay-purulia-sonkupi-banjara-camp-NC01", branch_description: "", managed_by: "", HotelBranchFacilityData: []
      },
      HotelRoomData: [
        { id: 122, org_id: 4, branch_id: 5, room_type_id: 14, room_number: "COT1", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "220", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 3 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "3500.00" },
        { id: 123, org_id: 4, branch_id: 5, room_type_id: 14, room_number: "COT2", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "220", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 3 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "3500.00" },
        { id: 124, org_id: 4, branch_id: 5, room_type_id: 14, room_number: "COT3", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "220", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 3 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "3500.00" },
        { id: 125, org_id: 4, branch_id: 5, room_type_id: 14, room_number: "COT4", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "220", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 3 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "3500.00" }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 23,
          room_type_id: 14,
          variant_id: 23,
          variant_wise_code: "COT-2A1C-EP",
          VarientRoomTypeDataRel: { id: 23, org_id: 4, branch_id: 5, start_date: null, end_date: null, code: "2A1C-EP", name: "Room Only", charge_basis: "per_room", max_adults: 2, max_children: 1, base_price: "0.00", rate_per_adult: null, rate_per_child: null, img_url: null, is_active: true, is_marketplace_availability: true, is_separate_from_room_type: false, VariantCompRelData: [] },
          computed_base_price: "0.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 23, name: "Room Only", variant_wise_code: "COT-2A1C-EP", base_price: "3500.00" }]
    },
    {
      id: 13,
      org_id: 4,
      branch_id: 5,
      room_type: "Delux Room",
      room_measurement: "200",
      no_of_beds: 2,
      num_of_bathrooms: 1,
      num_of_adult_max: 2,
      num_of_child_max: 1,
      num_of_adult_min: 2,
      num_of_child_min: 1,
      num_of_windows: 2,
      no_of_extra_person: null,
      basic_room_rate: "2200.00",
      basic_rate_set_date: "2025-08-28T11:55:00.000Z",
      base_num_of_rooms: "6",
      base_num_of_room_set_date: "2025-08-28T11:55:00.000Z",
      is_balcony_available: false,
      num_of_balcony: 0,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "",
      tag: null,
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T11:55:00.000Z",
      HotelBranchData: {
        id: 5, org_id: 4, branch_name: "Sonkupi Banjara Camp", email1: "puruliabanjaracamp@gmail.com", is_verified: true, email2: "", contact1: "919641858953", contact2: "", address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143", address2: "purulia", city: "purulia", state: "west bengal", zip: "723143", country: "india", google_location: "", owner_name: "Sujit Chandra Kumar", owner_address: "", currency: "INR", upi_id: "chhowburu1@ybl", qr_img_url: "", bank_details: "", breakfast_rate: "0.00", lunch_rate: "0.00", dinner_rate: "0.00", star_category: "0", property_type: "Homestay", can_be_booked: true, description: null, tag1: "", tag2: "", tag3: "", child_age_limit: 11, child_fooding: "", is_active: true, inactive_date: null, is_deleted: false, timezone: "Asia/Kolkata", social_media_url: "[]", branch_logo: "", is_beneficiary_included: false, is_agent: false, brochure_url: "", is_default: false, in_house_product: false, slug: "homestay-purulia-sonkupi-banjara-camp-NC01", branch_description: "", managed_by: "", HotelBranchFacilityData: []
      },
      HotelRoomData: [
        { id: 116, org_id: 4, branch_id: 5, room_type_id: 13, room_number: "DLX1", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2200.00" },
        { id: 117, org_id: 4, branch_id: 5, room_type_id: 13, room_number: "DLX2", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2200.00" },
        { id: 118, org_id: 4, branch_id: 5, room_type_id: 13, room_number: "DLX3", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2200.00" },
        { id: 119, org_id: 4, branch_id: 5, room_type_id: 13, room_number: "DLX4", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2200.00" },
        { id: 120, org_id: 4, branch_id: 5, room_type_id: 13, room_number: "DLX5", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2200.00" },
        { id: 121, org_id: 4, branch_id: 5, room_type_id: 13, room_number: "DLX6", is_active: true, HotelRoomPropertyRelation: [{ tag: "", room_measurement: "200", num_of_bathrooms: 1, num_of_adult_max: 2, num_of_child_max: 1, num_of_windows: 2 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "2200.00" }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 22,
          room_type_id: 13,
          variant_id: 22,
          variant_wise_code: "DLX-2A1C-MAP",
          VarientRoomTypeDataRel: { id: 22, org_id: 4, branch_id: 5, start_date: null, end_date: null, code: "2A1C-MAP", name: "Modified American Plan", charge_basis: "per_room", max_adults: 2, max_children: 1, base_price: "300.00", rate_per_adult: null, rate_per_child: null, img_url: null, is_active: true, is_marketplace_availability: true, is_separate_from_room_type: false, VariantCompRelData: [] },
          computed_base_price: "300.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 22, name: "Modified American Plan", variant_wise_code: "DLX-2A1C-MAP", base_price: "2500.00" }]
    },
    {
      id: 12,
      org_id: 4,
      branch_id: 5,
      room_type: "Deluxe Cottage",
      room_measurement: "280",
      no_of_beds: 4,
      num_of_bathrooms: 2,
      num_of_adult_max: 4,
      num_of_child_max: 2,
      num_of_adult_min: 4,
      num_of_child_min: 2,
      num_of_windows: 4,
      no_of_extra_person: null,
      basic_room_rate: "4000.00",
      basic_rate_set_date: "2025-08-28T11:50:00.000Z",
      base_num_of_rooms: "2",
      base_num_of_room_set_date: "2025-08-28T11:50:00.000Z",
      is_balcony_available: true,
      num_of_balcony: 1,
      is_breakfast_available: false,
      is_lunch_available: false,
      is_dinner_available: false,
      description: "Spacious cottage with garden view",
      tag: "family",
      is_active: true,
      is_dormitory: false,
      createdAt: "2025-08-28T11:50:00.000Z",
      HotelBranchData: {
        id: 5, org_id: 4, branch_name: "Sonkupi Banjara Camp", email1: "puruliabanjaracamp@gmail.com", is_verified: true, email2: "", contact1: "919641858953", contact2: "", address1: "Chhowburu Tourism Purulia, Baghmundi, Purulia, 723143", address2: "purulia", city: "purulia", state: "west bengal", zip: "723143", country: "india", google_location: "", owner_name: "Sujit Chandra Kumar", owner_address: "", currency: "INR", upi_id: "chhowburu1@ybl", qr_img_url: "", bank_details: "", breakfast_rate: "0.00", lunch_rate: "0.00", dinner_rate: "0.00", star_category: "0", property_type: "Homestay", can_be_booked: true, description: null, tag1: "", tag2: "", tag3: "", child_age_limit: 11, child_fooding: "", is_active: true, inactive_date: null, is_deleted: false, timezone: "Asia/Kolkata", social_media_url: "[]", branch_logo: "", is_beneficiary_included: false, is_agent: false, brochure_url: "", is_default: false, in_house_product: false, slug: "homestay-purulia-sonkupi-banjara-camp-NC01", branch_description: "", managed_by: "", HotelBranchFacilityData: []
      },
      HotelRoomData: [
        { id: 114, org_id: 4, branch_id: 5, room_type_id: 12, room_number: "DCOT1", is_active: true, HotelRoomPropertyRelation: [{ tag: "family", room_measurement: "280", num_of_bathrooms: 2, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 4 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "4000.00" },
        { id: 115, org_id: 4, branch_id: 5, room_type_id: 12, room_number: "DCOT2", is_active: true, HotelRoomPropertyRelation: [{ tag: "family", room_measurement: "280", num_of_bathrooms: 2, num_of_adult_max: 4, num_of_child_max: 2, num_of_windows: 4 }], HotelRoomFacilityRelation: [], basic_room_rate_with_special_rate: "4000.00" }
      ],
      RoomTypeFacilityRelation: [],
      HotelRoomTypeVarientRelData: [
        {
          id: 21,
          room_type_id: 12,
          variant_id: 21,
          variant_wise_code: "DCOT-4A2C-AP",
          VarientRoomTypeDataRel: { id: 21, org_id: 4, branch_id: 5, start_date: null, end_date: null, code: "4A2C-AP", name: "All Inclusive", charge_basis: "per_room", max_adults: 4, max_children: 2, base_price: "800.00", rate_per_adult: null, rate_per_child: null, img_url: null, is_active: true, is_marketplace_availability: true, is_separate_from_room_type: false, VariantCompRelData: [] },
          computed_base_price: "800.00"
        }
      ],
      branch_images: [],
      variantPrice: [{ id: 21, name: "All Inclusive", variant_wise_code: "DCOT-4A2C-AP", base_price: "4800.00" }]
    }
  ]
};

// Simulated API delay
const simulateDelay = (ms: number = 300) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Room Inventory API - Single endpoint that returns complete room type and variant data
 * This mirrors the actual API structure where room types contain their variants
 */
export const roomInventoryApi = {
  /**
   * Fetch room inventory - returns complete data with room types and their variants
   * Uses the booking scheduler API endpoint
   */
  async fetchRoomInventory(): Promise<RoomInventoryResponse> {
    const data = await fetchRoomTypes();
    return {
      success: true,
      total: data.length,
      data
    };
  }
};

/**
 * Fetch room types for booking scheduler
 * GET /hotel_room_types?data_target=booking_schedular&filters={"branch_id":77}
 * @param branchId - Optional branch ID to filter room types
 */
export async function fetchRoomTypes(branchId?: string | number): Promise<RoomInventoryItem[]> {
  if (USE_MOCK) {
    await delay();
    const filtered = branchId 
      ? mockRoomInventoryData.data.filter(item => item.branch_id === branchId)
      : mockRoomInventoryData.data;
    return filtered;
  }
  
  // Build filters object
  const filters = branchId ? { branch_id: branchId } : {};
  const filtersParam = Object.keys(filters).length > 0 
    ? `&filters=${encodeURIComponent(JSON.stringify(filters))}`
    : '';
  
  const url = `${API_ENDPOINTS.roomInventory.roomTypes}${filtersParam}`;
  
  const response = await apiClient.get<RoomInventoryResponse>(url);
  
  return response.data.data || [];
}

/**
 * Fetch room data with rate plans for today by branch
 * GET /hotel_room_types/roomDataTodayByBranch?filters={"branch_id":86}
 * Maps room inventory rate plans with channel manager rate plans
 * @param branchId - Branch ID to fetch room data for
 */
export async function fetchRoomDataTodayByBranch(branchId: string | number): Promise<RoomDataTodayResponse> {
  const filters = { branch_id: branchId };
  const filtersParam = `?filters=${encodeURIComponent(JSON.stringify(filters))}`;
  
  const url = `${API_ENDPOINTS.roomInventory.roomDataTodayByBranch}${filtersParam}`;
  
  const response = await apiClient.get<RoomDataTodayResponse>(url);
  
  return response.data;
}
